// If the value is an array, just return it, otherwise make a single entry array out of it and return it.
export const coerceArray = <T>(value: T | T[]) => (Array.isArray(value) ? value : [value]);

// Loops over each function in the array and calls them with the same arguments.
export const callEach =
  <T>(fns: ((args: T) => void)[]) =>
  (args: T) =>
    fns.forEach((fn) => fn(args));
